import Axios from 'axios'

export default function install(app, options={}) {

  // Craete axios instance with global config
  //
  const axios = Axios.create(options)

  // Create an interceptor to set the csrf token
  //
  if (options['csrfHeader']) {
    // Send authenticity token with each request.
    axios.interceptors.request.use(function(config) {
      const mv = document.querySelector('meta[name=csrf-token]');
      const t = mv ? mv.getAttribute('content') : '';
      config.headers['x-csrf-token'] = t;
      return config
    });
  }
	
	if (options['checkLogin']) {
		axios.interceptors.request.use(function(config) {
			const isLoggedIn = options['checkLogin']['with'];
			console.debug('interceptor: checkLogin');
			if (!isLoggedIn() ) {
				console.debug('interceptor: checkLogin returned false; redirecting');
				const controller = new AbortController();
				controller.abort();
				options['checkLogin']['handler']();
				return {...config, signal: controller.signal};
			}
			return config;
		})
	}

	if (options['authenticationFailure']) {
		axios.interceptors.response.use(
			response => response,
			error => {
				const status = error?.response?.status;
				if (status === 401) {
					options['authenticationFailure'](error);
				}
				return Promise.reject(error);
			}
		);
	}
  
  if (options['basePath']) {
    axios.interceptors.request.use(function(config) {
      console.warn('http: basePath unimplemented; consider using baseURL');
      return config;
    });
  }
  
  if (options['authorization']) {
    axios.interceptors.request.use(function(config) {
      config.headers['Authentication'] = options.authorization();
      return config;
    });
  }

  app.config.globalProperties.axios = axios;

  // Install in store if present.
  let store;
  if ((store = app.config.globalProperties.$store)) {
    store.axios = axios;
  }
  
  if (app.config.globalProperties.sharedStore) {
    app.config.globalProperties.sharedStore.axios = axios;
  }
  
  return app;
}
